import type { RenterProfileApiData } from '@/src/lib/api/endpoints/user';

type BooleanString = 'true' | 'false';

export type RenterProfileFormData = {
  moveInDate?: string;
  moveInTimeFrame?: string;
  leaseDuration?: number | null;
  incomeYearly?: number;
  numBeds?: number;
  numOccupants?: number;
  desiredPets?: string;
  creditScore?: string;
  creditScoreMin?: number;
  creditScoreMax?: number;
  desiredParking?: string;
};

function padZero(value: number): string {
  return value < 10 ? `0${value}` : String(value);
}

function toBooleanString(value?: string): BooleanString {
  return value === 'true' ? 'true' : 'false';
}

export function transformRenterProfileFromApi(data: RenterProfileApiData = {}): RenterProfileFormData {
  const result: RenterProfileFormData = {};

  if (data.moveInDate && Array.isArray(data.moveInDate)) {
    const [year, month, day] = data.moveInDate;
    result.moveInDate = `${year}-${padZero(month)}-${padZero(day)}`;
  }

  result.moveInTimeFrame = data.moveInTimeFrame ? data.moveInTimeFrame.toLowerCase() : '';

  result.leaseDuration = data.leaseLengthMonths ? Number(data.leaseLengthMonths) : null;

  result.incomeYearly = data.incomeYearly;

  result.numBeds =
    data.numBedrooms !== undefined && !isNaN(data.numBedrooms) && data.numBedrooms >= 0 ? data.numBedrooms : undefined;

  result.numOccupants = data.numOccupants;

  const petDetails = data.petDetails;
  result.desiredPets = petDetails && petDetails.length >= 1 && petDetails[0]?.type !== 'NONE' ? 'true' : 'false';

  if (data.creditScoreMin && data.creditScoreMax) {
    result.creditScore = `${data.creditScoreMin}-${data.creditScoreMax}`;
    result.creditScoreMin = data.creditScoreMin;
    result.creditScoreMax = data.creditScoreMax;
  }

  if (data.desiredParking !== undefined) {
    result.desiredParking = data.desiredParking === 'covered' ? 'true' : toBooleanString(data.desiredParking);
  }

  return result;
}
